module.exports = __webpack_public_path__ + "static/media/preview.634987f5.png";